module.exports = __webpack_public_path__ + "img/masCuidados.a58bf074.svg";